module.exports = __webpack_public_path__ + "img/02-Eisai-ฉันเป็นไหม.5f7ba39d.png";